import Header from "components/modules/landing/header/index";
import OurTechnology from "components/modules/landing/ourTechnology/index";
import AgTech from "components/modules/landing/AgTech/index";
import DigitalServices from "components/modules/landing/digitalServices/index";
import Platform from "components/modules/landing/platform";
import Farming from "components/modules/landing/farming/index";
import Mobile from "components/modules/landing/mobile/index";
import OurClint from "components/modules/landing/ourClint/index";
import Footer from "components/modules/landing/footer/index";
import { Suspense } from "react";

function index() {
  return (
    <div className="flex flex-col w-full">
      <Suspense fallback>
        <Header />
      </Suspense>
      <Suspense fallback>
        <OurTechnology />
      </Suspense>
      <Suspense fallback>
        <AgTech />
      </Suspense>
      <Suspense fallback>
        <DigitalServices />
      </Suspense>
      <Suspense fallback>
        <Platform />
      </Suspense>
      <Suspense fallback>
        <Farming />
      </Suspense>
      <Suspense fallback>
        <Mobile />
      </Suspense>
      <Suspense fallback>
        <OurClint />
      </Suspense>
      <Suspense fallback>
        <Footer />
      </Suspense>
    </div>
  );
}

export default index;
